import { render, staticRenderFns } from "./page-main.vue?vue&type=template&id=ffd2e1fa&"
import script from "./page-main.vue?vue&type=script&lang=js&"
export * from "./page-main.vue?vue&type=script&lang=js&"
import style0 from "./page-main.vue?vue&type=style&index=0&id=ffd2e1fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports